var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('v-alert',{attrs:{"type":"info","dismissible":"","prominent":""}},[_vm._v("\n\t"+_vm._s(_vm.status)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }